import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const footerCategories = categories.slice(0, 4);

  return (
    <footer className="bg-secondary-100 pt-20 md:pt-24 pb-10 px-6 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16">
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4 pb-2 border-b border-secondary-300/60">Product</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-600 cursor-default">Features</span></li>
              <li><span className="text-sm text-foreground-600 cursor-default">Pricing</span></li>
              <li><span className="text-sm text-foreground-600 cursor-default">Updates</span></li>
              <li><span className="text-sm text-foreground-600 cursor-default">Roadmap</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4 pb-2 border-b border-secondary-300/60">Categories</h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <a href="#categories" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">
                  View all →
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4 pb-2 border-b border-secondary-300/60">Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/itaobuy-sheet-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                  Complete Guide
                </Link>
              </li>
              <li><span className="text-sm text-foreground-600 cursor-default">Safety</span></li>
              <li><span className="text-sm text-foreground-600 cursor-default">Contact</span></li>
              <li><span className="text-sm text-foreground-600 cursor-default">FAQ</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4 pb-2 border-b border-secondary-300/60">Legal</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-600 cursor-default">Privacy</span></li>
              <li><span className="text-sm text-foreground-600 cursor-default">Terms</span></li>
              <li><span className="text-sm text-foreground-600 cursor-default">Disclaimer</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-300/60 pt-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-2 mb-2">
              <span className="font-heading text-6xl md:text-7xl font-thin text-foreground-900 leading-none">itaobuy.</span>
              <span className="font-heading text-6xl md:text-7xl font-extrabold text-foreground-900 leading-none">sheet</span>
            </div>
            <div className="flex items-center gap-3 mt-1">
              <span className="w-10 h-px bg-secondary-400"></span>
              <p className="text-xs text-foreground-500">Curated sourcing data for modern e-commerce.</p>
            </div>
          </div>

          <div className="flex flex-col items-start md:items-end gap-4">
            <p className="text-xs text-foreground-500">&copy; 2026 itaobuy.quest</p>
            <div className="flex items-center gap-4">
              <a href="#" aria-label="Instagram" className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" aria-label="Twitter / X" className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" aria-label="TikTok" className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}